import { createContext, useContext } from 'react';
import { Reporting, ReportingContextState } from 'modules/iterableGoals/types';
import noop from 'utils/noop';

export const initialReportingContextState: ReportingContextState = {
  isRevenue: false,
  reportingBy: Reporting.EVENT,
  updateReportingBy: noop,
  getReportingTranslation: (key: string) => key,
};

export const ReportingContext = createContext<ReportingContextState>(initialReportingContextState);

export const useReportingContext = () => useContext(ReportingContext);
